<div class="product-row-detail">
  @if (isLoading) {
    <div class="spinner-container">
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  } @else if (product) {
    <div class="detail-content">
      <div class="image-section">
        <img
          [src]="product.imageList?.[0] || noImage"
          [alt]="product.partName"
          class="product-image"
          (error)="onImageError($event)"
        />
        @if (product.imageList?.length) {
          <ds-button
            size="medium"
            type="secondary"
            variant="label-only"
            [label]="appStrings.products_gridViewAllImages"
            (onClick)="openImageGallery()">
          </ds-button>
        }
      </div>
      <div class="info-section">
        <div class="long-description">
          <typography variant="caption-2" weight="regular" class="label">
            {{ appStrings.products_gridLongDescription }}
          </typography>
          <typography variant="body-2" weight="bold">{{ product.partName }}</typography>
        </div>
        <ds-divider></ds-divider>
        <div class="attributes-grid">
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridSupersede }}</typography>
            <typography variant="body-2" weight="medium">{{ product.supersede || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridLifecycle }}</typography>
            <typography variant="body-2" weight="medium">{{ product.lifecycle || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridCommodityCode }}</typography>
            <typography variant="body-2" weight="medium">{{ product.commodityCode || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_SIN }}</typography>
            <typography variant="body-2" weight="medium">{{ product.sin || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridWarrantyCode }}</typography>
            <typography variant="body-2" weight="medium">{{ product.warrantyCode || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridSignalCode }}</typography>
            <typography variant="body-2" weight="medium">{{ product.signalCode || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridAlternateProduct }}</typography>
            <typography variant="body-2" weight="medium">{{ product.alternateProduct || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridManufacturer }}</typography>
            <typography variant="body-2" weight="medium">{{ product.manufacturer || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridReturnable }}</typography>
            <typography variant="body-2" weight="medium">{{ product.returnable || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridRepairable }}</typography>
            <typography variant="body-2" weight="medium">{{ product.repairable || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridDirectDelivery }}</typography>
            <typography variant="body-2" weight="medium">{{ product.directDelivery || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridPriceCategory }}</typography>
            <typography variant="body-2" weight="medium">{{ product.priceCategory || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridMinimumQuantity }}</typography>
            <typography variant="body-2" weight="medium">{{ product.minimumQuantity ?? '-' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridLimitedMarketing }}</typography>
            <typography variant="body-2" weight="medium">{{ product.limitedMarketing || 'N/A' }}</typography>
          </div>
          <div class="attribute">
            <typography variant="caption-2" weight="regular" class="label">{{ appStrings.products_gridExportCcn }}</typography>
            <typography variant="body-2" weight="medium">{{ product.exportCcn || '-' }}</typography>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <span class="no-details">{{ appStrings.products_gridNoDetails }}</span>
  }
</div>
